import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ScreeningQuestionnaireActions } from '@shared/store/screening-questionnaire/screening-questionnaire.actions';
import { Router } from '@angular/router';

export interface ScreeningQuestionnaireStateModel {
  answers: number[];

  requiredScore: number;

  hasReferral: boolean;
}

@State<ScreeningQuestionnaireStateModel>({
  name: 'screening_questionnaire',
  defaults: {
    answers: new Array(4),
    requiredScore: 4,
    hasReferral: false
  }
})
@Injectable()
export class ScreeningQuestionnaireState {
  constructor(private router: Router) {
  }

  @Action(ScreeningQuestionnaireActions.SetQuestionValue)
  async setQuestionValue(ctx: StateContext<ScreeningQuestionnaireStateModel>, payload: ScreeningQuestionnaireActions.SetQuestionValue) {
    const questionNumber: number = payload.index + 1;
    const answers = [ ...ctx.getState().answers ];
    answers[payload.index] = payload.value;
    ctx.patchState({ answers: answers });
    if (payload.value) {
      if (questionNumber === answers.length) {
        this.router.navigate([ 'auth', 'registration-start' ]);
      } else {
        this.router.navigate([ 'auth', 'screening-questionnaire', questionNumber + 1 ]);
      }
    } else {
      this.router.navigate([ 'auth', 'help-unneeded' ]);
    }

  }

  @Action(ScreeningQuestionnaireActions.ClearQuestionValues)
  async clearQuestionValues(ctx: StateContext<ScreeningQuestionnaireStateModel>, payload: ScreeningQuestionnaireActions.ClearQuestionValues) {
    const answers = [ ...ctx.getState().answers ];
    for (let i = payload.fromIndex; i < 4; i++) {
      answers[i] = undefined;
    }
    ctx.patchState({ answers });
  }

  @Action(ScreeningQuestionnaireActions.ConfirmReferenceStartRegistration)
  async confirmReferenceStartRegistration(ctx: StateContext<ScreeningQuestionnaireStateModel>, payload: ScreeningQuestionnaireActions.ConfirmReferenceStartRegistration) {
    ctx.patchState({ hasReferral: true });
    this.router.navigate([ 'auth', 'registration-start' ]);
  }

  @Action(ScreeningQuestionnaireActions.ConfirmReferralMissing)
  async confirmReferralMissing(ctx: StateContext<ScreeningQuestionnaireStateModel>, payload: ScreeningQuestionnaireActions.ConfirmReferralMissing) {
    ctx.patchState({ hasReferral: false });
    this.router.navigate([ 'fill-content', 'referral-missing' ]);
  }

}